module.exports = __webpack_public_path__ + "static/media/Vendas3.78d277ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancVendas/Vendas3.png
// module id = 1773
// module chunks = 0